import React from "react";

import * as Styled from "./styles";

export type CheckboxProps = {
  dataQA: string;
  label?: string;
  checked?: boolean;
  onChange: (checked: boolean) => void;
};

const Checkbox: React.FC<CheckboxProps> = ({
  dataQA,
  label,
  checked = false,
  onChange,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <Styled.CheckboxWrapper>
      <Styled.HiddenCheckbox
        checked={checked}
        onChange={handleChange}
        data-qa={dataQA}
      />
      <Styled.Checkbox $checked={checked} />
      <Styled.LabelText>{label}</Styled.LabelText>
    </Styled.CheckboxWrapper>
  );
};

export default Checkbox;
